import React from "react";

export const CircleArrowHeadIcon = () => {
  return (
    <>
      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="29.3573" height="29.3465" rx="14.6732" fill="#0562C0"/>
        <rect x="0.5" y="0.5" width="29.3573" height="29.3465" rx="14.6732" stroke="#CCCCCC"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M16.3233 15.1732L12.4325 11.4043C12.1959 11.1751 12.1959 10.7956 12.4325 10.5664C12.6587 10.3472 13.018 10.3472 13.2442 10.5664L18 15.1732L13.2442 19.7801C13.018 19.9992 12.6587 19.9992 12.4325 19.7801C12.1959 19.5509 12.1959 19.1713 12.4325 18.9421L16.3233 15.1732Z" fill="white" stroke="white" strokeWidth="0.5"/>
      </svg>
    </>
  );
};
